import styled, { keyframes } from 'styled-components';

// Animated ellipsis for loading indicator
const dotBounce = keyframes`
  0% { opacity: 0.3; transform: translateY(0); }
  40% { opacity: 1; transform: translateY(-4px); }
  80% { opacity: 0.3; transform: translateY(0); }
  100% { opacity: 0.3; transform: translateY(0); }
`;

const DotsContainer = styled.div`
  display: inline-flex;
  gap: 6px;
  align-items: center;
  span {
    display: inline-block;
    width: 6px;
    height: 6px;
    background: currentColor;
    border-radius: 50%;
    opacity: 0.3;
    animation: ${dotBounce} 1.2s infinite;
  }
  span:nth-child(1) {
    animation-delay: 0s;
  }
  span:nth-child(2) {
    animation-delay: 0.15s;
  }
  span:nth-child(3) {
    animation-delay: 0.3s;
  }
`;

const LoadingDots = () => (
  <DotsContainer>
    <span />
    <span />
    <span />
  </DotsContainer>
);

export default LoadingDots;
